/* import __COLOCATED_TEMPLATE__ from './attribute.hbs'; */
/**

 ## Attribute

 The `sq-card/attributes-list/attribute` block component is designed to be used as a contextual component in: [sq-card/attributes-list](/components/glass/sq-card/attributes-list.html).

 **/

import { isPresent } from '@ember/utils';
import { assert } from '@ember/debug';
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['card__attributes-list__attribute'],
  classNameBindings: ['isFullWidth:card__attributes-list__attribute--is-full-width'],
  attributeBindings: ['data-test-card-attribute'],
  'data-test-card-attribute': true,
  // Passed in:
  isFullWidth: false,
  label: null,
  value: null,
  didReceiveAttrs() {
    this._super();
    assert('You must pass translated `label` string to `{{card/attribute-list/attribute}}`', isPresent(this.get('label')));
  }
});